export const isFloatString = (value) =>
  value?.length === 0 || value.replace(/\s/g, '').match(/^[+-]?\d+(\.\d+)?$/)
